export default {
    products: state => state.products,
    metadata: state => state.metadata,
    purchasesModel: state => state.purchasesModel,
    rcConfig: state => state.rcConfig,
    recentPurchase: state => state.recentPurchase,
    openPurchasesFromMenu: state => state.openPurchasesFromMenu,
}